var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"inner-app"},[_c('layoutDefault')],1),_c('div',{attrs:{"id":"landscape-message"}},[_vm._v(" Please rotate your device to portrait mode for the best experience. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }